import { useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { store, routerHistory } from '../redux/redux-config';

export default function navigate(relativeUrl) {

    if (routerHistory.location?.state?.temporary)
        routerHistory.replace({ pathname: relativeUrl });
    else
        store.dispatch(push(relativeUrl, { from: routerHistory.location.pathname }));
}

export function handleGoBack() {
    const location = routerHistory.location;
    const from = location?.state?.from || "/";
    store.dispatch(push(from));
};

export function useNavState(selector) {
    return useSelector(store => selector(store.router.location?.state || {}));
}

export function pushNavState(state) {
    routerHistory.push({ state: { ...state, temporary: true } });
}

export function popNavState() {
    if (routerHistory.location?.state?.temporary)
        routerHistory.goBack();
}


// Don't let the forward or back button bring up a temporary state
setTimeout(() => {
    routerHistory.listen(function (e, type) {
        if (type === "POP" && e.state?.temporary) {
            routerHistory.replace(e.pathname, undefined);
            e.state = undefined;
        }
    });
}, 0);